import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { BrandMark } from "@/components/brand/BrandMark";

const DISMISS_KEY = "doxa_pwa_dismissed";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isMobile = () =>
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.matchMedia("(max-width: 767px)").matches;
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const ios = isIOS();

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) === "1") return;
    if (isStandalone() || !isMobile()) return;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    if (ios) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, [ios]);

  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch (_) {}
    setDeferred(null);
    dismiss();
  };

  return (
    <div
      className="fixed bottom-4 inset-x-3 z-50 mx-auto max-w-md rounded-2xl border border-[#E0D9CD] bg-white shadow-lg p-4 animate-in"
      data-testid="pwa-install-prompt"
    >
      <div className="flex items-start gap-3">
        <BrandMark size="md" />
        <div className="min-w-0 flex-1">
          <p className="font-display font-bold text-[#1F1F1F]">Instale o Doxa School no celular</p>
          <p className="text-xs text-[#6B655E] mt-0.5">Acesse mais rápido pela tela inicial, como um aplicativo.</p>

          {ios && !deferred ? (
            <p className="text-xs text-[#6B655E] mt-2 inline-flex items-center gap-1">
              Para instalar no iPhone: toque em <Share className="w-3.5 h-3.5 inline text-[#F75A1B]" /> Compartilhar e depois em
              <span className="font-medium"> Adicionar à Tela de Início</span>.
            </p>
          ) : null}

          <div className="flex items-center gap-2 mt-3">
            {deferred && (
              <button
                onClick={install}
                className="doxa-btn-primary px-3 py-1.5 text-sm inline-flex items-center gap-1.5"
                data-testid="pwa-install-btn"
              >
                <Download className="w-3.5 h-3.5" /> Instalar app
              </button>
            )}
            <button
              onClick={dismiss}
              className="px-3 py-1.5 text-sm rounded-xl border border-[#E0D9CD] text-[#6B655E] hover:text-[#F75A1B]"
              data-testid="pwa-dismiss-btn"
            >
              Entendi
            </button>
          </div>
        </div>
        <button onClick={dismiss} className="text-[#6B655E] hover:text-[#1F1F1F] shrink-0" data-testid="pwa-close-btn" aria-label="Fechar">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
